import { StandardsModal } from "./StandardsModal";

export { StandardsModal };
